/** Format minutes-in-state as `Nm` / `Nh` / `Nh Mm`. */
export function formatStage(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

/** Format an SLA delta in minutes with explicit sign (e.g. `+25m`, `-1h 15m`). */
export function formatSla(deltaMinutes: number): string {
  const sign = deltaMinutes >= 0 ? '+' : '-';
  const abs = Math.abs(deltaMinutes);
  if (abs < 60) return `${sign}${abs}m`;
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  return m === 0 ? `${sign}${h}h` : `${sign}${h}h ${m}m`;
}

/** Label a call-attempt chip, e.g. `1 AI call`, `3 human calls`. */
export function formatCallAttempts(count: number, kind: 'AI' | 'human'): string {
  return `${count} ${kind} ${count === 1 ? 'call' : 'calls'}`;
}
